import Table from "components/DataTable/Table";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import { convertSqlTimestampToDate } from "utils/UtilityFuncs";

export default function MOAudit({ selectedWO }) {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  /*   ALL STATES
   ********************************************* */

  const [auditData, setAuditData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  /*   All Functions
   ********************************************* */
  //get Data
  const getAuditData = async (m_productId) => {
    try {
      setLoading(true);
      const { data } = await API.get(
        `/wo-product-audit/${selectedWO?.m_woId}/${m_productId}`,
        {
          headers: authHeader(),
        },
      );
      if (data?.success) {
        setAuditData(data?.data);
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  const getTime12HoursFormat = (time) => {
    // 2025-07-18T15:04:39.000Z
    const date = new Date(time);
    const options = {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    };
    return date.toLocaleString("en-US", options);
  };

  /*   Table functions
   ********************************************* */
  const btn1 = () => (
    <select
      className="form-select"
      style={{ width: "300px" }}
      value={selectedProduct || ""}
      onChange={(e) => {
        setSelectedProduct(parseInt(e.target.value, 10) || null);
      }}
    >
      <option value="">Select Product</option>
      {selectedWO &&
        selectedWO?.m_woProducts &&
        selectedWO?.m_woProducts?.map((item) => (
          <option key={item.id} value={item.m_productId}>
            {item.m_productId} - {item.productStyle} -{" "}
            {item?.productDescription}
          </option>
        ))}
    </select>
  );

  const table_head = [
    "Product Id",
    "Type",
    "Updated By",
    "createdBy",
    "updatedAt",
    "createDate",
  ];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td>{item.updatedProductId}</td>
      <td>{item.type}</td>
      <td className="py-1 me-0">{`${item.updater?.firstName} ${item.updater?.lastName}`}</td>
      <td className="py-1 me-0">{`${item.creator?.firstName} ${item.creator?.lastName}`}</td>
      <td>
        {convertSqlTimestampToDate(item.updatedAt)} -{" "}
        {getTime12HoursFormat(item.updatedAt)}
      </td>
      <td>
        {convertSqlTimestampToDate(item.createDate)} -{" "}
        {getTime12HoursFormat(item.createDate)}
        {console.log(item.createDate)}
      </td>
    </tr>
  );

  /*   UseEffect
   ********************************************* */

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (selectedProduct) {
        getAuditData(selectedProduct);
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [selectedProduct]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (
        selectedWO &&
        selectedWO?.m_woProducts &&
        selectedWO?.m_woProducts.length > 0
      ) {
        let _selectedProduct = searchParams.get("m_productId");
        console.log("Selected Product:", _selectedProduct);

        if (_selectedProduct) {
          setSelectedProduct(parseInt(_selectedProduct, 10));
        } else {
          setSelectedProduct(selectedWO?.m_woProducts[0]?.m_productId);
        }
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [selectedWO, searchParams]);

  return (
    <div className="p-2">
      {loading && <Spinner />}
      {/*   Table
       ********************************************* */}
      <div
        className="px-1 flex-grow-1 overflow-y-auto d-flex"
        style={{ height: "78vh", borderRadius: 15 }}
      >
        <div className="horizontal-scrollable d-flex flex-grow-1">
          <Table
            btn1={btn1}
            table_head={table_head}
            table_body={table_body}
            table_data={auditData}
            disableSearch={true}
          />
        </div>
      </div>
    </div>
  );
}
